import useDisableRubberBandScrolling from '@medflex/hooks/useDisableRubberBandScrolling';
import * as PropTypes from 'prop-types';
import * as React from 'react';

const PhysicianWelcomeScreen = ({ children }) => {
  const divRef = useDisableRubberBandScrolling();
  return (
    <div
      data-component="PhysicianWelcomeScreen"
      ref={divRef}
      className="h-full w-full flex justify-center overflow-y-auto bg-slate-100"
    >
      <div className="flex-col max-w-6xl flex-auto p-4 pt-8 min-w-0">{children}</div>
    </div>
  );
};

PhysicianWelcomeScreen.propTypes = {
  children: PropTypes.node,
};

export default PhysicianWelcomeScreen;
